import { useEffect, useState } from 'react';

export default function useDelayedVisibility(active, delayMs = 1000) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setVisible(true);
    }, Math.max(0, Number(delayMs) || 0));

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [active, delayMs]);

  return visible;
}
